import { render, staticRenderFns } from "./BusinessTypeServices.vue?vue&type=template&id=5eed66ce&scoped=true&"
import script from "./BusinessTypeServices.vue?vue&type=script&lang=js&"
export * from "./BusinessTypeServices.vue?vue&type=script&lang=js&"
import style0 from "./BusinessTypeServices.vue?vue&type=style&index=0&id=5eed66ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eed66ce",
  null
  
)

export default component.exports